import { HubApiMethods } from '../../constants/HubApiMethods';
import { addLoginQueryParams } from '../../utils/url';
import { appendUnityLoginIframe } from '../../utils/landing';
import { HubJsonRpcRequest } from '../../api/HubJsonRpcRequest';
import { GetUserTokenType } from '../../domains/valueObject/SwitchUserProgressResponses';
import { CustomJrpcErrResult } from '../../general/modules/jsonRpc/jRpcErrResponse';
import { MailingUser } from './MailingUser';
import { getUrlToLoginViaToken } from '../getUrlToLoginViaToken';
import { container } from '../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../utils/container/service-ids';
import { FlagNames } from '../../utils/feature-flags/flag-names';
import { getHubApi } from '../../general/modules/accountServiceApi/getAccountServiceApi';

export class MailingLogin {
    private mailingUser: MailingUser;

    constructor(mailingUser: MailingUser) {
        this.mailingUser = mailingUser;
    }

    public async auth(): Promise<void> {
        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

        let hubResponse: CustomJrpcErrResult | GetUserTokenType;

        try {
            if (!isHubApiEnabled) {
                hubResponse = await HubJsonRpcRequest.makeRequest(
                    HubApiMethods.GET_TOKEN_BY_MAILING_TOKEN,
                    {
                        locale: this.mailingUser.getLocale(),
                        entryPoint: this.mailingUser.getEntryPoint(),
                        mailingToken: this.mailingUser.getMailingToken(),
                        suid: this.mailingUser.getSuid(),
                        generatedAt: this.mailingUser.getGeneratedAt()
                    },
                    this.mailingUser.getDeviceId()
                );

                if ('error' in hubResponse) {
                    throw new Error(hubResponse.error.message);
                }
            } else {
                const hubApi = getHubApi();
                hubResponse = await hubApi.getTokenByMailingToken(this.mailingUser.getDeviceId(), {
                    locale: this.mailingUser.getLocale(),
                    entryPoint: this.mailingUser.getEntryPoint(),
                    mailingToken: this.mailingUser.getMailingToken(),
                    suid: this.mailingUser.getSuid(),
                    generatedAt: this.mailingUser.getGeneratedAt()
                });
            }

            let url = getUrlToLoginViaToken(hubResponse.tether.token, hubResponse.tether.suid);
            url = addLoginQueryParams(url);
            appendUnityLoginIframe(url);
        } catch (exception) {
            window.Sentry.captureException(`Got exception on mailing login ${JSON.stringify(exception)}`);
        }
    }
}
